import { useState } from "react";
import { Box, Button } from "@mui/material";
import { ClarificationQuestion } from "../types/ginoQuery";

const isArabic = (text: string) => /[\u0600-\u06FF]/.test(text);

const ClarificationChips = ({ question, onAnswer }: { question: ClarificationQuestion; onAnswer: (key: string, value: string) => void }) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  if (!question.options?.length) return null;

  // RTL when the question or its options are Arabic — flip chip alignment/padding.
  const rtl = isArabic(question.question) || question.options.some(isArabic);

  return (
    <Box
      dir={rtl ? "rtl" : "ltr"}
      sx={{ ...styles.container, pl: rtl ? 0 : "42px", pr: rtl ? "42px" : 0, justifyContent: rtl ? "flex-end" : "flex-start" }}
    >
      {question.options.map((option, idx) => (
        <Button
          key={idx}
          sx={{ ...styles.chip, ...(selectedValue === option ? styles.selected : selectedValue ? styles.disabled : {}) }}
          onClick={() => { setSelectedValue(option); onAnswer(question.key, option); }}
        >
          {option}
        </Button>
      ))}
    </Box>
  );
};

export default ClarificationChips;

const styles = {
  container: { display: "flex", flexWrap: "wrap", gap: "8px", mt: "10px", pl: "42px" },
  chip: { padding: "8px 16px", background: "#fff", border: "1.5px solid #d7ece0", borderRadius: "9999px", fontSize: 13, fontWeight: 600, color: "#106048", fontFamily: "Montserrat", textTransform: "none", boxShadow: "0 1px 2px rgba(16,24,40,0.04)", transition: "all 0.16s ease", "&:hover": { background: "#106048", borderColor: "#106048", color: "#fff", transform: "translateY(-1px)", boxShadow: "0 4px 12px -4px rgba(16,96,72,0.4)" } },
  selected: { background: "linear-gradient(135deg, #12855f 0%, #106048 100%) !important", color: "#fff !important", borderColor: "#106048 !important", pointerEvents: "none" },
  disabled: { opacity: 0.4, pointerEvents: "none" },
};
